// extracted by mini-css-extract-plugin
module.exports = {"container":"SuggestionBanner_container__mv1jp"};